module.exports = __webpack_public_path__ + "static/media/395W_Hyundai.672cf764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/395W_Hyundai.jpg
// module id = 1066
// module chunks = 0